/**
 * Piletilevi Sales terminal services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * - PENDING means that the invite hasn\'t been accepted yet or has been but the invitee doesn\'t have a user yet - EXPIRED means that the invite hasn\'t been accepted within the expiring time 
 */
export type InviteStatus = 'PENDING' | 'EXPIRED';

export const InviteStatus = {
    Pending: 'PENDING' as InviteStatus,
    Expired: 'EXPIRED' as InviteStatus
};

